var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThreeDotsVertical(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 4,
    height: 10,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 7.42c.32 0 .6.12.83.35.23.24.35.51.35.83 0 .32-.12.6-.35.83-.24.23-.51.35-.83.35-.32 0-.6-.12-.83-.35-.23-.24-.35-.51-.35-.83 0-.32.12-.6.35-.83.24-.23.51-.35.83-.35Zm0-3.5c.32 0 .6.12.83.35.23.24.35.51.35.83 0 .32-.12.6-.35.83-.24.23-.51.35-.83.35-.32 0-.6-.12-.83-.35-.23-.24-.35-.51-.35-.83 0-.32.12-.6.35-.83.24-.23.51-.35.83-.35Zm0-1.14c-.32 0-.6-.12-.83-.35-.23-.24-.35-.51-.35-.83 0-.32.12-.6.35-.83.24-.23.51-.35.83-.35.32 0 .6.12.83.35.23.24.35.51.35.83 0 .32-.12.6-.35.83-.24.23-.51.35-.83.35Z",
    fill: "#97A1BC"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThreeDotsVertical);
export default __webpack_public_path__ + "static/media/three-dots-vertical.d42810dfe38bfa7b4489aa94e94c8ae3.svg";
export { ForwardRef as ReactComponent };